import { HelpLinkIFrame as HelpLinkIFrameStyled } from '@wrisk/ui-components'
import React, { FunctionComponent, IframeHTMLAttributes, useState } from 'react'

import { DynamicDataOptions } from '../../../clients/assets'
import { useErrorHandlingAsync } from '../../../hooks/errors'
import { useDependencies } from '../../../state'

export interface HelpLinkIFrameProps extends IframeHTMLAttributes<HTMLIFrameElement> {
  src: string | undefined
  dynamicDataOptions?: DynamicDataOptions
}

export const HelpLinkIFrame: FunctionComponent<HelpLinkIFrameProps> = ({
  dynamicDataOptions,
  src,
  ...props
}) => {
  const assetClient = useDependencies().assetClient
  const [asset, setAsset] = useState<string | undefined>()

  useErrorHandlingAsync(
    async (url: string, dynamicDataOptions: DynamicDataOptions) => {
      if (url) {
        const doc = await assetClient.getAsset(url, dynamicDataOptions)
        setAsset(doc)
      }
    },
    [src, dynamicDataOptions],
  )

  return <HelpLinkIFrameStyled {...props} srcDoc={asset} />
}
